export default __webpack_public_path__ + "static/media/logo_GMX.eb702c03.svg";